import React, { useState, useEffect } from "react"
import paymentBanksService from '../../services/paymentBank';
import ScrollableTable from '../DataGrid/DataGrid';

import './ModalPaymentBanks.scss';

import editIcon from '../../assets/edit-icon.png';
// import deleteIcon from '../../assets/delete-icon.png';

function ModalPaymentBanks({onCloseModal, paymentBankData}) {
  const [paymentBanks, setPaymentBanks] = useState([]);
  const [deleteSup, setDelete] = useState(0);

  const TableHeaders = [{
    Header: '-',
    columns: [
      {
          Header: 'Pagamento/Banco',
          accessor: 'paymentBank',
          textAlign: 'left',
          width: 220,
      },
      {
        Header: 'Ações',
        accessor: 'action',
        textAlign: 'left',
        width: 120,
      }
    ]
  }];

  const rows = paymentBanks.map((value, index) => {
    return {
      paymentBank: value.name,
      action: (<>
        {/* <button style={{ float: 'right' }} onClick={() => setDelete(1)}><img src={deleteIcon} style={{ width: '18px', height: '18px' }} /></button> */}
        <button style={{ float: 'right' }} onClick={() => paymentBankData(paymentBanks[index])}><img src={editIcon} alt="Editar Pagamento/Banco" style={{ width: '18px', height: '18px' }} /></button>
      </>),
      key: index,
    }
  });

  useEffect(() => {
    const getPaymentBanks = async () => {
      try {
        const paymentBank = await paymentBanksService.getAll();
        setPaymentBanks(paymentBank.data);
      } catch (error) {
        console.error('Error fetching PaymentBank:', error);
      }
    };

    getPaymentBanks();
  }, []);

  return (
    <>
      <div className='modal-paymentbank'>
        <div className="inner-content">
          {!deleteSup ? (
            <>
              <button className="btn-close" onClick={() => onCloseModal(false)}>X</button>
              <h3>Pagamentos/Bancos Cadastrados</h3>
              {rows.length > 0 ? (
                <ScrollableTable headers={TableHeaders} height={'60vh'} dataRows={rows} />
              ) : (
                <p>Carregando...</p>
              )}
            </>
          ) : (
            <>
              <div className="wrapper-delete">
                <h3>Excluir Pagamento/Banco?</h3>
                <button className={'btn--primary'}>Sim</button>
                <button className={'btn--primary'} onClick={() => setDelete(0)}>Não</button>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  )
}

export default ModalPaymentBanks;
